// @ts-strict-ignore
import { QualifiedSecurityId } from 'phoenix/models/QualifiedSecurityId';
import { Sum } from 'phoenix/util';
import { useRelavantPositions, useRelevantPositionsV2 } from './UseRelavantPositions';

export const useQuantityHeld = (secId: QualifiedSecurityId, accountNumber: string | null): number => {
    const relevantPositions = useRelavantPositions(secId, accountNumber);

    if (!accountNumber || !secId) return null;
    else return Sum(relevantPositions?.map((p) => p?.quantity || 0));
};

export const useQuantityHeldV2 = (secId: QualifiedSecurityId, accountNumber: string | null): number => {
    const relevantPositions = useRelevantPositionsV2(secId, accountNumber);

    if (!accountNumber || !secId) return null;
    else return Sum(relevantPositions?.map((p) => p?.quantity || 0));
};
